/** Recently-viewed customers, kept per device in localStorage. */

const KEY = 'igf-recent-companies'
const MAX = 8

export interface RecentCompany {
  id: string
  name: string
  shortName: string
  at: number
}

export function getRecentCompanies(): RecentCompany[] {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? (parsed as RecentCompany[]) : []
  } catch {
    return []
  }
}

export function clearRecentCompanies() {
  try {
    localStorage.removeItem(KEY)
  } catch {
    return
  }
}

export function pushRecentCompany(entry: Omit<RecentCompany, 'at'>) {
  try {
    const now = Date.now()
    const existing = getRecentCompanies().filter((c) => c.id !== entry.id)
    const next = [{ ...entry, at: now }, ...existing].slice(0, MAX)
    localStorage.setItem(KEY, JSON.stringify(next))
  } catch {
    /* ignore */
  }
}
